import loadDetailsTypes from './loadDetailsTypes'

export const initialState = {
  loadingBid: false,
  bidError: '',
  loadingBook: false,
  bookError: '',
  mapImage: '',
  loadingMapImage: false,
  mapImageError: '',
  loadDetails: {},
  tractorDetails: null,
  tractorDetailsError: ''
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case loadDetailsTypes.OPEN_LOAD_DETAILS:
      return {
        ...state,
        loadDetails: payload
      }

    case loadDetailsTypes.CLEAR_LOAD_DETAILS:
      return {
        ...state,
        loadDetails: {},
        tractorDetails: null
      }

    case loadDetailsTypes.BID_OFFER:
    case loadDetailsTypes.BID_ORDER:
      return {
        ...state,
        loadingBid: true,
        bidError: ''
      }

    case loadDetailsTypes.BID_OFFER_SUCCESS:
    case loadDetailsTypes.BID_ORDER_SUCCESS: {
      const details = { ...state.loadDetails }
      if (details && details.load) {
        if (payload.movement_id === details.load.movementNumber) {
          details.load = {
            ...state.loadDetails.load,
            order_status: 'BID'
          }
        }
      }
      return {
        ...state,
        loadingBid: false,
        bidError: '',
        loadDetails: details
      }
    }

    case loadDetailsTypes.BID_OFFER_FAILURE:
    case loadDetailsTypes.BID_ORDER_FAILURE: {
      return {
        ...state,
        loadingBid: false,
        bidError: payload
      }
    }

    case loadDetailsTypes.BOOK_OFFER:
    case loadDetailsTypes.BOOK_ORDER:
      return {
        ...state,
        loadingBook: true,
        bookError: ''
      }

    case loadDetailsTypes.BOOK_OFFER_SUCCESS:
    case loadDetailsTypes.BOOK_ORDER_SUCCESS: {
      const details = { ...state.loadDetails }
      if (details && details.load) {
        if (payload.movement_id === details.load.movementNumber) {
          details.load = {
            ...state.loadDetails.load,
            order_status: 'BOOK'
          }
        }
      }
      return {
        ...state,
        loadingBook: false,
        bookError: '',
        loadDetails: details
      }
    }

    case loadDetailsTypes.BOOK_OFFER_FAILURE:
    case loadDetailsTypes.BOOK_ORDER_FAILURE: {
      return {
        ...state,
        loadingBook: false,
        bookError: payload
      }
    }

    case loadDetailsTypes.GET_MAP_IMAGE:
      return {
        ...state,
        loadingMapImage: true,
        mapImage: '',
        mapImageError: ''
      }

    case loadDetailsTypes.GET_MAP_IMAGE_SUCCESS: {
      return {
        ...state,
        loadingMapImage: false,
        mapImageError: '',
        mapImage: payload
      }
    }

    case loadDetailsTypes.GET_MAP_IMAGE_FAILURE: {
      return {
        ...state,
        loadingMapImage: false,
        mapImageError: payload
      }
    }

    case loadDetailsTypes.GET_TRACTOR_DETAILS:
      return {
        ...state,
        tractorDetails: null,
        tractorDetailsError: ''
      }

    case loadDetailsTypes.GET_TRACTOR_DETAILS_SUCCESS: {
      return {
        ...state,
        tractorDetails: payload,
        tractorDetailsError: ''
      }
    }

    case loadDetailsTypes.GET_TRACTOR_DETAILS_FAILURE: {
      return {
        ...state,
        tractorDetailsError: payload
      }
    }

    default: return state
  }
}
